// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import config from '../config';

const firebaseConfig = {
  apiKey: config.fcm.apiKey,
  authDomain: config.fcm.authDomain,
  projectId: config.fcm.projectId,
  storageBucket: config.fcm.storageBucket,
  messagingSenderId: config.fcm.messagingSenderId,
  appId: config.fcm.appId,
  measurementId: config.fcm.measurementId,
};

let messaging;

// Initialize Firebase
if (navigator && navigator.serviceWorker) {
  const app = initializeApp(firebaseConfig);
  getAnalytics(app);
  messaging = getMessaging(app);

  onMessage(messaging, (payload) => {
    const { title, body, url } = payload.data;

    // Manually show notification (optional)
    if (Notification.permission === 'granted') {
      new Notification(title, {
        body,
        icon: `${process.env.PUBLIC_URL}/favicon.ico`,
        data: { url },
      });
    }
  });
}

export { messaging, getToken };
